import React from 'react';
import { Controller, Control } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import TextField from 'common/components/TextField';
import ErrorPanel from 'common/components/ErrorPanel';
import { CUSTOMER_EMAIL } from '../../../../common/constants';
import { CheckoutValues } from 'store/ducks/checkout/types';

type Props = {
    checkoutValues: CheckoutValues;
    control: Control;
    errors: any;
};

const CustomerEmail: React.FC<Props> = ({ checkoutValues, control, errors }) => {
    const { email } = checkoutValues || {};

    return (
        <Grid item xs={12} md={5}>
            <Controller
                as={<TextField fullWidth />}
                control={control}
                defaultValue={email || ''}
                label="* Adres e-mail"
                name={CUSTOMER_EMAIL}
                variant="outlined"
            />
            <ErrorPanel errors={errors} name={CUSTOMER_EMAIL} />
        </Grid>
    );
};

export default CustomerEmail;
